import { ContactType } from 'common-package';
import { RouterConfigEnum } from '@portalCommon/constants/common';
import { toContactPage } from '@portalCommon/utils';
import { OptimizedImg } from '@commonPackage/components';
import { Consult } from '@/components';
import { SectionLayout } from '../../components/SectionLayout';
import { HoverSwipeCard } from '../../components/HoverSwipeCard';
import { TabCard } from '../../components/TabCard';
import { VideoCard } from '../../components/VideoCard';
import { ContactUs } from '../../components';
import { HOVER_SWIPE_DATA, TAB_CARD_DATA, VIDEO_SWIPE_DATA } from './helper';
import cx from './index.module.less';

export const CorporateSpace = () => {
  return (
    <div className={cx('space-wrapper')}>
      <div className={cx('section-one')}>
        <div className={cx('bg')}>
          <OptimizedImg src="https://static.fuxi.netease.com/yaotai/portal/index/ll3cq5we_649694.png" alt="" />
        </div>

        <div className={cx('section-box')}>
          <div className={cx('box-content')}>
            <div>企业元宇宙空间</div>
            <div>连接企业品牌与业务的双重载体</div>
            <div className={cx('tips')}>打造企业专属的全面、立体、动态的科技感品牌营销阵地，畅享无限元宇宙营销可能</div>
            <div
              className={cx('button')}
              onClick={() =>
                toContactPage({ contactType: ContactType.activity, isMain: import.meta.env.VITE_MAIN === 'true' })
              }>
              立即咨询
            </div>
          </div>
        </div>
      </div>
      <div className={cx('section-two')}>
        <VideoCard dataSource={VIDEO_SWIPE_DATA} />
      </div>
      <div className={cx('section-three')}>
        <SectionLayout
          className={cx('three-box')}
          title="解决方案亮点"
          subTitle="打造专属企业元宇宙空间，突破企业品牌营销新方式">
          <HoverSwipeCard dataSource={HOVER_SWIPE_DATA}></HoverSwipeCard>
        </SectionLayout>
      </div>

      <Consult routerPath={RouterConfigEnum.CorporateSpace} />
      <div className={cx('section-five')}>
        <SectionLayout
          className={cx('five-box')}
          title="特色功能"
          subTitle="多维度功能全面赋能，实现企业品牌宣传、商业转化多重需求">
          <TabCard dataSource={TAB_CARD_DATA} />
        </SectionLayout>
      </div>
      <ContactUs></ContactUs>
    </div>
  );
};

export default CorporateSpace;
